import Message from './Message';
import Vue from 'vue';
const defaults = {
    top: 24,
    duration: 3
};
let messageInstance;
const iconTypes = {
    'info': 'icon-info',
    'success': 'icon-success',
    'warning': 'icon-warning',
    'error': 'icon-error',
    'loading': 'icon-loading'
};

function getMessageInstance (msg = '', time = defaults.duration, type) {
    const iconType = iconTypes[type];
        const _props =  {
            duration: time,
            msgType: type,
            message: msg,
            iconType:iconType
        };
        const Instance = new Vue({
            render (h) {
                return h(Message, {
                    props: _props
                });
            }
        });
        const component = Instance.$mount();
        document.body.appendChild(component.$el);
        const notification = Instance.$children[0];
        return {
            destroy () {
                notification.close()
            }
        };
}


export default {
    name: 'Message',
    info (options) {
        return this.message('info', options);
    },
    success (options) {
        return this.message('success', options);
    },
    warning (options) {
        return this.message('warning', options);
    },
    error (options) {
        return this.message('error', options);
    },
    loading (options) {
        return this.message('loading', options);
    },
    message(type, options){
        if (typeof options === 'string') {
            //console.log("是否是字符串")
            options = {
                msg: options
            };
        }
        this.messageInstance=getMessageInstance(options.msg, options.time, type);
        return messageInstance;
    },
    close () {
 
        this.messageInstance.destroy()
    }
};


// WEBPACK FOOTER //
// ./src/components/Message/index.js